export default __webpack_public_path__ + "static/media/hospital-home-mobile.72ddc989.svg";